/**
 * FAQ 접근 테스트 유틸리티
 */
import { db, appId } from '../firebase/firebaseConfig.jsx';
import { collection, getDocs, doc } from 'firebase/firestore';

export async function testFAQAccess() {
  console.log('🧪 FAQ 접근 테스트 시작');
  console.log('📋 appId:', appId);
  
  const category = 'labor';
  const testPaths = [
    `artifacts/${appId}/consultation_faqs/${category}/faqs`,
    `artifacts/${appId}/consultation_faqs/${category}`
  ];
  
  for (const path of testPaths) {
    try {
      console.log(`\n🔍 경로 테스트: ${path}`);
      const ref = collection(db, path);
      const snapshot = await getDocs(ref);
      console.log(`   ✅ 성공: ${snapshot.size}개 문서 발견`);
      
      if (snapshot.size > 0) {
        snapshot.forEach(docSnap => {
          const data = docSnap.data();
          console.log(`   - ID: ${docSnap.id}`);
          console.log(`     질문(ko): ${(data.question?.ko || '').substring(0, 50)}...`);
        });
      }
    } catch (error) {
      console.error(`   ❌ 실패: ${error.message}`);
      console.error(`   코드: ${error.code}`);
      
      // 서브컬렉션 방식 시도
      try {
        console.log(`   🔄 서브컬렉션 방식 시도...`);
        const parentDoc = doc(db, `artifacts/${appId}/consultation_faqs/${category}`);
        const subcollection = collection(parentDoc, 'faqs');
        const snapshot2 = await getDocs(subcollection);
        console.log(`   ✅ 서브컬렉션 방식 성공: ${snapshot2.size}개 문서 발견`);
      } catch (error2) {
        console.error(`   ❌ 서브컬렉션 방식도 실패: ${error2.message}`);
      }
    }
  }
  
  return { appId, success: true };
}

